/**
 * Simply Food Storage homepage hero slideshow.
 * - Multi-slide dots + optional autoplay
 * - Desktop: align copy left edge to the visible header logo
 */
(function () {
  var LOGO_MQ = window.matchMedia('(min-width: 750px)');

  function logoEl() {
    return (
      document.querySelector('.header__heading-logo') ||
      document.querySelector('.header__heading-link img') ||
      document.querySelector('.header__heading-link') ||
      document.querySelector('.header__heading')
    );
  }

  /**
   * Sets --sfs-hero-inline to the logo's viewport left so hero copy matches the wordmark.
   */
  function syncHeroToLogo() {
    var logo = logoEl();
    var heroes = document.querySelectorAll('[data-sfs-hero]');
    if (!heroes.length) return;

    if (!LOGO_MQ.matches || !logo) {
      heroes.forEach(function (hero) {
        hero.style.removeProperty('--sfs-hero-inline');
      });
      return;
    }

    var left = Math.round(logo.getBoundingClientRect().left);
    if (left < 0) left = 0;
    heroes.forEach(function (hero) {
      hero.style.setProperty('--sfs-hero-inline', left + 'px');
    });
  }

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sfs-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sfs-hero-dot]'));
    if (slides.length < 2) {
      root.classList.add('sfs-hero--single');
      return;
    }

    var index = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '6', 10) * 1000;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay) return;
      timer = setInterval(function () {
        show(index + 1);
      }, speed);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-sfs-hero]').forEach(initHero);
    syncHeroToLogo();
    window.addEventListener('resize', syncHeroToLogo);
    window.addEventListener('load', syncHeroToLogo);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeroToLogo);
    }
    // Logo image may load after first paint
    var logo = logoEl();
    if (logo && logo.tagName === 'IMG') {
      if (logo.complete) syncHeroToLogo();
      else logo.addEventListener('load', syncHeroToLogo);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
